import React from 'react';
import { MAIN_WHATSAPP_MESSAGE } from '../data/messages';
import { WhatsAppButton } from './WhatsAppButton';
import { PerksStrip } from './PerksStrip';
export function FinalCta() {
  return <section className="bg-navy-900 py-12 text-white sm:py-20" data-id="element-49" data-mp="19fgus0w3965v">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-50" data-mp="19cuos5ouiypr">
        <span className="guide-line mx-auto block h-px w-20 text-accent-500" aria-hidden="true" data-id="element-51" data-mp="15ckkcxgpcgd0" />
        <h2 className="mt-5 font-display text-[2rem] font-bold leading-tight sm:text-5xl" data-id="element-52" data-mp="1jbtxtpdiwwda">
          No sigas perdido entre proveedores. Cotiza claro y directo.
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-steel-200 sm:text-base" data-id="element-53" data-mp="1t3g9fmtrwxgk">
          Dinos material, piezas o m² y ciudad. Te respondemos por WhatsApp con precio, disponibilidad y fecha de
          entrega.
        </p>
        <div className="mt-6 flex flex-col items-center gap-3 sm:flex-row sm:justify-center" data-id="element-54" data-mp="223w90l7ebkg5">
          <WhatsAppButton message={MAIN_WHATSAPP_MESSAGE} label="Cotizar ahora por WhatsApp" location="cierre" size="lg" className="w-full shadow-lg shadow-black/30 sm:w-auto" data-id="element-55" data-mp="1x64edjfd9k89" />
          <a href="#cotizador" className="inline-flex w-full items-center justify-center rounded-md border border-white/25 px-7 py-4 text-base font-semibold text-white transition-colors duration-150 ease-out hover:border-white hover:bg-white/10 sm:w-auto" data-id="element-56" data-mp="x421ag9dlxgn">
            Armar mi pedido
          </a>
        </div>
      </div>
      <div className="mx-auto mt-10 max-w-content px-4 sm:px-6" data-id="element-57" data-mp="1b1qm5o3g14lp">
        <PerksStrip data-id="element-58" data-mp="1fvba0nbboi76" />
      </div>
    </section>;
}